import type { ReactElement } from 'react';
import { ActivationFlow } from './ActivationFlow';
import styles from './HomePage.module.css';

/**
 * Tela principal do Activation Runtime.
 * Serve como ponto de entrada para a ativação: enquanto os plugins reais
 * (Quiz/Roleta, HUB-26/27) não chegam, hospeda o fluxo de ativação fake do
 * piloto — validação de PIN + captura de lead fictício (HUB-147).
 *
 * O indicador de status de sincronização (`OnlineStatusIndicator`) é
 * renderizado por `ActivationFlow`, não aqui — desde a HUB-236 sua posição
 * é `fixed` (top-right do viewport, Design > Indicador de Status), então
 * uma única instância já cobre toda a tela independente de onde é montada;
 * duplicá-lo neste header criaria dois indicadores sobrepostos no mesmo
 * canto.
 *
 * `headerLogo`: marca aciona.ai como imagem única — mesma decisão do
 * usuário registrada na HUB-258 (aplicada lá em `manager-web/.../
 * brand-logo.tsx`): nunca recriar o wordmark em texto solto tentando imitar
 * a marca. Aqui usamos o ícone isolado (`public/brand/icon-aciona.svg`), não
 * o lockup ícone+wordmark horizontal do manager-web: o badge do header
 * deste app é um quadrado de 48px, espaço apertado demais pra um lockup
 * horizontal legível.
 *
 * `public/brand/icon-aciona.svg` é o único arquivo físico do ícone da marca
 * neste app — também referenciado como favicon em `index.html`
 * (`<link rel="icon">`). Antes da HUB-266 havia uma segunda cópia
 * byte-idêntica em `public/favicon.svg` (introduzida na HUB-259); os dois
 * pontos de consumo (favicon + badge do header) agora apontam para o mesmo
 * arquivo pra não exigir atualização manual em dois lugares se a marca
 * mudar de novo.
 */
export function HomePage(): ReactElement {
  return (
    <main className={styles.container} role="main">
      <header className={styles.header}>
        <div className={styles.headerLogo}>
          <img src="/brand/icon-aciona.svg" alt="aciona.ai" className={styles.headerLogoImg} />
        </div>
      </header>

      <section className={styles.pluginArea} aria-label="Área de ativação">
        <ActivationFlow />
      </section>
    </main>
  );
}
